var CONTINUOUS_MEASURE_TO_PIVOT, DEFAULT_CI_LEVEL, DOSE_RESPONSE_TO_PIVOT, DOWNGRADE_NAME_TO_PIVOT, GRADEPRO_AUTHORITY, IMPORTANCE_TO_PIVOT, LARGE_EFFECT_TO_PIVOT, OUTCOME_TYPE_TO_PIVOT, PLAUSIBLE_CONFOUNDING_TO_PIVOT, PUBLICATION_BIAS_TO_PIVOT, QUALITY_EXPORT_DOMAINS, QUALITY_TO_PIVOT, RELATIVE_MEASURE_TO_PIVOT, SCHEMA_URI, STUDY_TYPE_NON_RANDOMIZED, STUDY_TYPE_RANDOMIZED, buildEstimate, comparativeEvidenceSource, exportComparatorEffect, exportContinuousEffect, exportDichotomousAbsoluteEffects, exportDichotomousEffect, exportEffect, exportNarrativeEffect, exportOutcome, exportQuality, exportQualityDomain, firstNonBlank, flipAbsEstimate, followUpText, followUpUnitText, groupCounts, nameWithIdentifiers, omitsEffectEstimates, parseChangeScoreRange, parseInteger, parseNumber, preferredDirection, pushAbsoluteEffect, ratingWithComments, relativeEffect, resolveFootnoteTexts, scaleAbsToProportion, scaleControlRiskToProportion, studyType, _ref,
  __slice = [].slice;

_ref = require('./enums'), GRADEPRO_AUTHORITY = _ref.GRADEPRO_AUTHORITY, SCHEMA_URI = _ref.SCHEMA_URI, IMPORTANCE_TO_PIVOT = _ref.IMPORTANCE_TO_PIVOT, QUALITY_TO_PIVOT = _ref.QUALITY_TO_PIVOT, OUTCOME_TYPE_TO_PIVOT = _ref.OUTCOME_TYPE_TO_PIVOT, RELATIVE_MEASURE_TO_PIVOT = _ref.RELATIVE_MEASURE_TO_PIVOT, CONTINUOUS_MEASURE_TO_PIVOT = _ref.CONTINUOUS_MEASURE_TO_PIVOT, DOWNGRADE_NAME_TO_PIVOT = _ref.DOWNGRADE_NAME_TO_PIVOT, PUBLICATION_BIAS_TO_PIVOT = _ref.PUBLICATION_BIAS_TO_PIVOT, LARGE_EFFECT_TO_PIVOT = _ref.LARGE_EFFECT_TO_PIVOT, DOSE_RESPONSE_TO_PIVOT = _ref.DOSE_RESPONSE_TO_PIVOT, PLAUSIBLE_CONFOUNDING_TO_PIVOT = _ref.PLAUSIBLE_CONFOUNDING_TO_PIVOT, STUDY_TYPE_RANDOMIZED = _ref.STUDY_TYPE_RANDOMIZED, STUDY_TYPE_NON_RANDOMIZED = _ref.STUDY_TYPE_NON_RANDOMIZED, DEFAULT_CI_LEVEL = _ref.DEFAULT_CI_LEVEL;

parseChangeScoreRange = require('lib/change_score_range').parseChangeScoreRange;

firstNonBlank = function() {
  var value, values, _i, _len;
  values = 1 <= arguments.length ? __slice.call(arguments, 0) : [];
  for (_i = 0, _len = values.length; _i < _len; _i++) {
    value = values[_i];
    if (_.isString(value) && value.trim() !== '') {
      return value;
    }
  }
  return '';
};

nameWithIdentifiers = function(name, id) {
  var result;
  if (id == null) {
    id = null;
  }
  result = {
    name: name != null ? name : ''
  };
  if (id != null) {
    result.identifiers = [
      {
        authority: GRADEPRO_AUTHORITY,
        id: String(id)
      }
    ];
  }
  return result;
};

parseNumber = function(value) {
  var num;
  if (!((value != null) && value !== '')) {
    return void 0;
  }
  num = _.isNumber(value) ? value : parseFloat(value);
  if (_.isNaN(num)) {
    return void 0;
  } else {
    return num;
  }
};

parseInteger = function(value) {
  var num;
  num = parseNumber(value);
  if (num == null) {
    return void 0;
  }
  return Math.round(num);
};

resolveFootnoteTexts = function(footnoteIds, footnotesList) {
  var id, notes, text, texts, _i, _len, _ref1, _ref2;
  notes = (_ref1 = footnotesList != null ? footnotesList.notes : void 0) != null ? _ref1 : {};
  texts = [];
  _ref2 = footnoteIds != null ? footnoteIds : [];
  for (_i = 0, _len = _ref2.length; _i < _len; _i++) {
    id = _ref2[_i];
    text = notes[String(id)];
    if (text != null) {
      texts.push(text);
    }
  }
  return texts;
};

buildEstimate = function(value, from, to) {
  var estimate, f, t, v;
  estimate = {};
  v = parseNumber(value);
  f = parseNumber(from);
  t = parseNumber(to);
  if (v != null) {
    estimate.value = v;
  }
  if (f != null) {
    estimate['ci-start'] = f;
  }
  if (t != null) {
    estimate['ci-end'] = t;
  }
  if (_.isEmpty(estimate)) {
    return void 0;
  }
  return estimate;
};

flipAbsEstimate = function(size, from, to) {
  var flipped, fromNum, sizeNum, toNum;
  sizeNum = parseNumber(size);
  fromNum = parseNumber(from);
  toNum = parseNumber(to);
  flipped = {
    value: sizeNum != null ? -sizeNum : void 0,
    from: toNum != null ? -toNum : void 0,
    to: fromNum != null ? -fromNum : void 0
  };
  return flipped;
};

scaleAbsToProportion = function(value, denominator) {
  if (value == null) {
    return void 0;
  }
  if ((denominator != null) && denominator !== 0) {
    return value / denominator;
  } else {
    return value;
  }
};

scaleControlRiskToProportion = function(value) {
  if (value == null) {
    return void 0;
  }
  return value / 100;
};

preferredDirection = function(outcome) {
  if (outcome.higherIsBetter === true) {
    return 'POSITIVE';
  } else if (outcome.higherIsBetter === false) {
    return 'NEGATIVE';
  } else {
    return 'NOT_APPLICABLE';
  }
};

followUpUnitText = function(unit, othersText) {
  var resolved;
  resolved = unit === 'others' ? othersText : unit;
  if (resolved === 'patientYears') {
    return 'patient years';
  } else {
    return resolved != null ? resolved : '';
  }
};

followUpText = function(outcome) {
  var hasNumericLength, length, plain, toUnitText, unitText, _ref1;
  length = outcome.followUpLength;
  hasNumericLength = (length != null) && length !== '' && Number(length) !== 0;
  if (!hasNumericLength) {
    if (outcome.followUpTimeUnit !== 'others') {
      return;
    }
    plain = String((_ref1 = outcome.othersFollowUpTimeUnit) != null ? _ref1 : '').trim();
    if (plain) {
      return plain;
    } else {
      return void 0;
    }
  }
  unitText = followUpUnitText(outcome.followUpTimeUnit, outcome.othersFollowUpTimeUnit);
  if (outcome.followUpType === 'range' && (outcome.followUpLengthTo != null)) {
    toUnitText = followUpUnitText(outcome.followUpToTimeUnit, outcome.othersFollowUpToTimeUnit);
    return ("" + length + " " + unitText + " to " + outcome.followUpLengthTo + " " + toUnitText).trim();
  } else {
    return ("" + length + " " + unitText).trim();
  }
};

studyType = function(outcome) {
  var name, _ref1;
  name = (_ref1 = outcome.designStudies) != null ? _ref1.name : void 0;
  if (!name) {
    return void 0;
  }
  if (name === 'RandTrials') {
    return STUDY_TYPE_RANDOMIZED;
  } else if (name === 'ObsStudies' || name === 'NonRandStudy' || name === 'SingleArm') {
    return STUDY_TYPE_NON_RANDOMIZED;
  } else {
    return void 0;
  }
};

omitsEffectEstimates = function(outcome) {
  var _ref1;
  return (_ref1 = outcome.metaType) === 'NOT_POOLED' || _ref1 === 'NOT_REPORTED' || _ref1 === 'NOT_MEASURED';
};

comparativeEvidenceSource = function(outcome) {
  if (omitsEffectEstimates(outcome)) {
    return void 0;
  }
  switch (outcome.metaType) {
    case 'SINGLE_STUDY':
      return {
        name: 'Primary study',
        type: 'PRIMARY_STUDY'
      };
    case 'POOLED':
    case 'RANGE_OF_EFFECTS':
      return {
        name: 'Pooled',
        type: 'SYNTHESIS'
      };
    default:
      return void 0;
  }
};

ratingWithComments = function(value, comments) {
  var result;
  if (!((value != null) || (comments != null ? comments.length : void 0))) {
    return void 0;
  }
  result = {};
  if (value != null) {
    result.value = value;
  }
  if (comments != null ? comments.length : void 0) {
    result.comments = comments;
  }
  return result;
};

exportQualityDomain = function(grade, footnoteIds, footnotesList, nameToPivot) {
  var comments, pivotValue;
  comments = resolveFootnoteTexts(footnoteIds, footnotesList);
  pivotValue = (grade != null ? grade.name : void 0) ? nameToPivot[grade.name] : void 0;
  return ratingWithComments(pivotValue, comments);
};

QUALITY_EXPORT_DOMAINS = [['risk-of-bias', 'riskOfBias', DOWNGRADE_NAME_TO_PIVOT], ['inconsistency', 'inconsistency', DOWNGRADE_NAME_TO_PIVOT], ['indirectness', 'indirectness', DOWNGRADE_NAME_TO_PIVOT], ['imprecision', 'imprecision', DOWNGRADE_NAME_TO_PIVOT], ['publication-bias', 'publicationBias', PUBLICATION_BIAS_TO_PIVOT], ['large-effect', 'largeEffect', LARGE_EFFECT_TO_PIVOT], ['plausible-confounding', 'plausibleConfounding', PLAUSIBLE_CONFOUNDING_TO_PIVOT], ['dose-response-gradient', 'doseResponseGradient', DOSE_RESPONSE_TO_PIVOT]];

exportQuality = function(outcome, footnotesList) {
  var footnotes, gdtKey, nameToPivot, overall, overallComments, pivotKey, quality, rating, _i, _len, _ref1, _ref2;
  quality = {};
  overall = QUALITY_TO_PIVOT[outcome.quality];
  if (overall != null) {
    quality.value = overall;
  }
  footnotes = (_ref1 = outcome.footnotes) != null ? _ref1 : {};
  overallComments = resolveFootnoteTexts(footnotes.quality, footnotesList);
  if (overallComments != null ? overallComments.length : void 0) {
    quality.comments = overallComments;
  }
  for (_i = 0, _len = QUALITY_EXPORT_DOMAINS.length; _i < _len; _i++) {
    _ref2 = QUALITY_EXPORT_DOMAINS[_i], pivotKey = _ref2[0], gdtKey = _ref2[1], nameToPivot = _ref2[2];
    rating = exportQualityDomain(outcome[gdtKey], footnotes[gdtKey], footnotesList, nameToPivot);
    if (rating != null) {
      quality[pivotKey] = rating;
    }
  }
  if (_.isEmpty(quality)) {
    return void 0;
  }
  return quality;
};

groupCounts = function(casesValue, sampleSize) {
  var c, group, s;
  group = {};
  c = parseInteger(casesValue);
  s = parseInteger(sampleSize);
  if (c != null) {
    group.cases = c;
  }
  if (s != null) {
    group['sample-size'] = s;
  }
  if (_.isEmpty(group)) {
    return void 0;
  }
  return group;
};

relativeEffect = function(outcome) {
  var estimate, measure, pivotMeasure, result, _ref1, _ref2;
  measure = outcome.effectMeasure;
  if (!((measure != null) && measure !== '')) {
    return void 0;
  }
  pivotMeasure = (_ref1 = RELATIVE_MEASURE_TO_PIVOT[measure]) != null ? _ref1 : 'OTHER';
  result = {
    'effect-measure': pivotMeasure
  };
  if (pivotMeasure === 'OTHER') {
    result['other-effect-measure'] = (_ref2 = outcome.otherMeasure) != null ? _ref2 : measure;
  }
  estimate = buildEstimate(outcome.effectSize, outcome.confidenceIntervalFrom, outcome.confidenceIntervalTo);
  if (estimate != null) {
    result.estimate = estimate;
  }
  return result;
};

pushAbsoluteEffect = function(effects, opts) {
  var comparatorRisk, denom, effect, estimate, flipped;
  flipped = flipAbsEstimate(opts.size, opts.from, opts.to);
  denom = opts.denominator;
  estimate = buildEstimate(scaleAbsToProportion(flipped.value, denom), scaleAbsToProportion(flipped.from, denom), scaleAbsToProportion(flipped.to, denom));
  effect = {};
  comparatorRisk = scaleControlRiskToProportion(parseNumber(opts.controlRisk));
  if (comparatorRisk != null) {
    effect['comparator-risk'] = comparatorRisk;
  }
  if (opts.controlRiskIsCalculated != null) {
    effect['comparator-risk-is-calculated'] = opts.controlRiskIsCalculated;
  }
  if (estimate != null) {
    effect.estimate = estimate;
  }
  if (opts.estimateIsCalculated != null) {
    effect['estimate-is-calculated'] = opts.estimateIsCalculated;
  }
  if (_.isEmpty(effect) || ((estimate == null) && (comparatorRisk == null))) {
    return;
  }
  return effects.push(effect);
};

exportDichotomousAbsoluteEffects = function(outcome, denominator) {
  var effects;
  effects = [];
  if (outcome.calculatedControl || (outcome.absEffectSize != null) || (outcome.calculatedControlValue != null)) {
    pushAbsoluteEffect(effects, {
      size: outcome.absEffectSize,
      from: outcome.absEffectFrom,
      to: outcome.absEffectTo,
      controlRisk: outcome.calculatedControlValue,
      controlRiskIsCalculated: outcome.calculatedControl !== false,
      estimateIsCalculated: outcome.absEffectAutoCalc !== false,
      denominator: denominator
    });
  }
  if (outcome.lowControl) {
    pushAbsoluteEffect(effects, {
      size: outcome.absEffectSizeLow,
      from: outcome.absEffectFromLow,
      to: outcome.absEffectToLow,
      controlRisk: outcome.lowControlRisk,
      controlRiskIsCalculated: false,
      estimateIsCalculated: outcome.absEffectAutoCalcLow !== false,
      denominator: denominator
    });
  }
  if (outcome.moderateControl) {
    pushAbsoluteEffect(effects, {
      size: outcome.absEffectSizeModerate,
      from: outcome.absEffectFromModerate,
      to: outcome.absEffectToModerate,
      controlRisk: outcome.moderateControlRisk,
      controlRiskIsCalculated: false,
      estimateIsCalculated: outcome.absEffectAutoCalcModerate !== false,
      denominator: denominator
    });
  }
  if (outcome.highControl) {
    pushAbsoluteEffect(effects, {
      size: outcome.absEffectSizeHigh,
      from: outcome.absEffectFromHigh,
      to: outcome.absEffectToHigh,
      controlRisk: outcome.highControlRisk,
      controlRiskIsCalculated: false,
      estimateIsCalculated: outcome.absEffectAutoCalcHigh !== false,
      denominator: denominator
    });
  }
  return effects;
};

exportDichotomousEffect = function(outcome) {
  var absEffects, comparator, denominator, effect, intervention, rel, _ref1;
  effect = {};
  intervention = groupCounts(outcome.interventionCount, outcome.interventionTotal);
  comparator = groupCounts(outcome.controlCount, outcome.controlTotal);
  if (intervention != null) {
    effect['intervention-group'] = intervention;
  }
  if (comparator != null) {
    effect['comparator-group'] = comparator;
  }
  denominator = parseInteger((_ref1 = outcome.absDenominator) != null ? _ref1 : outcome.perPatients);
  if (denominator != null) {
    effect.denominator = denominator;
  }
  effect['preferred-direction'] = preferredDirection(outcome);
  if (!omitsEffectEstimates(outcome)) {
    rel = relativeEffect(outcome);
    if (rel != null) {
      effect['relative-effect'] = rel;
    }
    absEffects = exportDichotomousAbsoluteEffects(outcome, denominator);
    if (absEffects.length) {
      effect['absolute-effects'] = absEffects;
    }
  }
  return effect;
};

exportContinuousEffect = function(outcome) {
  var comparator, comparatorEffect, effect, estimate, intervention, measure, pivotMeasure, _ref1;
  effect = {};
  intervention = groupCounts(null, outcome.interventionTotal);
  comparator = groupCounts(null, outcome.controlTotal);
  if (intervention != null) {
    effect['intervention-group'] = intervention;
  }
  if (comparator != null) {
    effect['comparator-group'] = comparator;
  }
  if (!omitsEffectEstimates(outcome)) {
    measure = outcome.effectMeasure;
    pivotMeasure = CONTINUOUS_MEASURE_TO_PIVOT[measure];
    if (pivotMeasure != null) {
      effect['effect-measure'] = pivotMeasure;
    } else if (measure != null) {
      effect['effect-measure'] = 'OTHER';
      effect['other-effect-measure'] = (_ref1 = outcome.otherMeasure) != null ? _ref1 : measure;
    }
    estimate = buildEstimate(outcome.effectSize, outcome.confidenceIntervalFrom, outcome.confidenceIntervalTo);
    if (estimate != null) {
      effect.estimate = estimate;
    }
  }
  if (outcome.units) {
    effect.unit = outcome.units;
  }
  effect['preferred-direction'] = preferredDirection(outcome);
  comparatorEffect = exportComparatorEffect(outcome);
  if (comparatorEffect != null) {
    effect['comparator-effect'] = comparatorEffect;
  }
  return effect;
};

exportComparatorEffect = function(outcome) {
  var endpoints, hasValue, num, type, valueStr;
  type = outcome.changeScoreInControls;
  valueStr = outcome.changeScoreInControlsValue;
  hasValue = (valueStr != null) && valueStr !== '';
  if (!(type || hasValue)) {
    return void 0;
  }
  if (type === 'mean' || type === 'median') {
    num = parseNumber(valueStr);
    if (num != null) {
      return {
        'value-type': type.toUpperCase(),
        value: num
      };
    }
  }
  if (type === 'range' && hasValue) {
    endpoints = parseChangeScoreRange(valueStr);
    if (endpoints != null) {
      return {
        'value-type': 'RANGE',
        'range-start': endpoints[0],
        'range-end': endpoints[1]
      };
    }
    return {
      'value-type': 'TEXT',
      'text-value': String(valueStr)
    };
  }
  if (hasValue) {
    return {
      'value-type': 'TEXT',
      'text-value': String(valueStr)
    };
  }
  return void 0;
};

exportNarrativeEffect = function(outcome) {
  return {
    description: outcome.narrativeDesc || outcome.comments || ''
  };
};

exportEffect = function(outcome, pivotType) {
  switch (pivotType) {
    case 'CONTINUOUS':
      return exportContinuousEffect(outcome);
    case 'NARRATIVE':
      return exportNarrativeEffect(outcome);
    default:
      return exportDichotomousEffect(outcome);
  }
};

exportOutcome = function(outcome, footnotesList) {
  var comment, importance, pivotType, quality, result, source, st, studyCount, timeframe, _ref1;
  pivotType = (_ref1 = OUTCOME_TYPE_TO_PIVOT[outcome.type]) != null ? _ref1 : 'DICHOTOMOUS';
  result = nameWithIdentifiers(outcome.name, outcome._id);
  result['outcome-type'] = pivotType;
  source = comparativeEvidenceSource(outcome);
  if (source != null) {
    result['comparative-evidence-source'] = source;
  }
  studyCount = parseInteger(outcome.noOfStudies);
  if (studyCount != null) {
    result['study-count'] = studyCount;
  }
  st = studyType(outcome);
  if (st != null) {
    result['study-type'] = st;
  }
  timeframe = followUpText(outcome);
  if (timeframe != null) {
    result.timeframe = timeframe;
  }
  result.effect = exportEffect(outcome, pivotType);
  quality = exportQuality(outcome, footnotesList);
  if (quality != null) {
    result.quality = quality;
  }
  if (outcome.importance != null) {
    importance = IMPORTANCE_TO_PIVOT[Number(outcome.importance)];
    if (importance != null) {
      result.importance = importance;
    }
  }
  comment = outcome.comments || outcome.plain_language_summary;
  if (comment) {
    result.comment = comment;
  }
  return result;
};

module.exports = {
  exportQuestion: function(questionData) {
    var footnotesList, sof, _ref1, _ref2;
    sof = {
      '$schema': SCHEMA_URI,
      name: firstNonBlank(questionData.tableTitle, questionData.question),
      'ci-level': DEFAULT_CI_LEVEL,
      population: nameWithIdentifiers(questionData.healthProblemOrPopulation),
      setting: nameWithIdentifiers((_ref1 = questionData.settings) != null ? _ref1 : ''),
      intervention: nameWithIdentifiers(questionData.intervention),
      comparator: nameWithIdentifiers(questionData.comparison),
      outcomes: []
    };
    if (questionData._id != null) {
      sof.identifiers = [
        {
          authority: GRADEPRO_AUTHORITY,
          id: String(questionData._id)
        }
      ];
    }
    footnotesList = questionData.footnotesList;
    sof.outcomes = _.map((_ref2 = questionData.outcomes) != null ? _ref2 : [], function(outcome) {
      return exportOutcome(outcome, footnotesList);
    });
    return sof;
  }
};
